<template>
    <div>
        <Header>
            <div class="buttons-right">
                <save-button id="settings-save" name="Settings" :status="saving" @save="save()"></save-button>
            </div>
        </Header>

        <div class="page page--medium">

            <div class="block" v-if="!userProfile">
                <div class="loading-gif" >
                    <img :src="VUE_APP_STATIC_URL + 'img/loading.gif'">
                </div>
            </div>

            <div class="block" v-if="userProfile">
                <h3 class="block__heading" v-t="'Profile Bio'"></h3>

                <field :errors="errors" v-if="userProfile" label="Portfolio Title" name="portfolio_title" :help="$t('Displayed on your home page and in the page title')">
                    <input id="settings-title" v-model="userProfile.portfolio_title" type="text">
                </field>

                <div class="field field-width" style="clear:both;margin-top: 10px;">

                    <Redactor id="settings-bio" v-model="userProfile.short_bio" :config="{buttons: ['formatting', '|', 'bold', 'italic',  'link'], plugins: ['fontsize', 'alignment', 'html'],toolbarFixed: false}" />

                </div>
            </div>
            <div  class="block" v-if="userProfile">
                <h3  class="block__heading" v-t="'Profile Image'"></h3>
                <div class="field field-width">
                    <!-- <label>{{field.name}}</label> -->

                    <image-resizer @save="save()" :user="userProfile"></image-resizer>

                </div>
            </div>
            <div  class="block" v-if="userProfile">
                <h3  class="block__heading" v-t="'Social Links'"></h3>
                <field :errors="errors" class="field field-switch">
                    <label class="switch">
                        <input v-model="userProfile.show_blog_social_links" type="checkbox">
                        <div class="slider round"></div>
                    </label>
                    <span class="label" v-t="'Show article share links on blog posts?'"></span>
                </field>


                  <div>
                    <div class="profile-social-links">
                      <div v-for="link in userSocialLinks" class="social-link">
                        <div class="img-1">
                          <img style="width: 35px;" :src="'https://static.journoportfolio.com/public/icons/colour/'+link.icon+'.png'">
                          </div>
                          <div class="social-link__link"><p>{{link.data}}</p></div>
                          <div class="remove">
                            <a @click="removeSocialAccount(link)"><i class="material-icons">delete</i></a>
                          </div>
                      </div>
                    </div>

                    <field
                      :errors="errors"
                      :label="$t('Add Social Link')"
                      name="social_links"
                      class="field--social-links"
                      :help="$t('Enter URL, Email address or Phone number to display as icons')"
                    >
                      <div class="input-wrapper">
                      <input
                        id="settings-title"
                        v-model="social_url"
                        type="url"
                        v-on:keyup.enter="addSocialLink"
                      />
                      <a v-if="social_url!=''" @click="addSocialLink()" class="social_add">Add</a>
                      </div>
                    </field>
                  </div>



            </div>
            <div class="block" v-if="userProfile">
                <h3 class="block__heading" v-t="'Your CV/Resume'"></h3>

                <div class="alert">
                    <i class="material-icons">warning</i>
                    <p>
                        This file is publicly accessible on the internet. Do not upload details that you don't want visible online.
                    </p>
                </div>

                <div class="field field--file field-width">

                    <file-picker v-bind:cv="true" @remove="removeCV()" :model="userProfile.cv" @changed="changeCV($event)" title="Upload a CV"></file-picker>

                </div>
            </div>
            <div class="block" v-if="userProfile">
                <h3 class="block__heading" v-t="'Export portfolio as PDF'"></h3>

                <p>You can export your portfolio as PDF with the button below. You should download it and share or print it, instead of linking to the URL.</p>

                <p>At present it simply includes all of your articles. We are working on adding various options to change how it is exported.</p>

                <a class="button" target="_blank" :href="getPDFURL">Export as PDF</a>
            </div>
            <div class="block" v-if="userProfile">
                <h3 class="block__heading" v-t="'Footer Text'"></h3>
                <div class="field field--file field-width">

                    <Redactor id="settings-footer-text" v-model="userProfile.footer_text" :config="{buttons: ['formatting', '|', 'bold', 'italic',  'link'], plugins: ['fontsize', 'alignment', 'html'],toolbarFixed: false}" />

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Header from '@/components/Header.vue'
    import Field from '@/components/Field.vue'
    import SaveButton from '@/components/SaveButton.vue'
    import ImageResizer from  '@/components/ImageResizer.vue'
    import FilePicker from  '@/components/FilePicker.vue'
    import Redactor from  '@/components/Redactor.vue'

    export default {
        components: {
            Header,
            Field,
            SaveButton,
            ImageResizer,
            FilePicker,
            Redactor
        },
        data () {
            return {
                VUE_APP_STATIC_URL: process.env.VUE_APP_STATIC_URL,
                userProfile: null,
                errors: {},
                saving: false,
                  userSocialLinks: null,
                  social_url: '',
                  ICON_COLOR_MAP: {
                    discord: '#5865f2', phone: '#ff6a6a',facebook: '#3b5998',email: '#333',cv: '#333',twitter: '#45b0e3',linkedin: '#0177b5',whatsapp: '#00a859',codepen: '#0f0f0f',website: '#b2b2b2',instagram: '#d51a6f',reddit: '#ff4600',medium: '#00ab6c',vimeo: '#17b3e8',behance: '#000000',fivehundredpx: '#333',dribbble: '#ea4c89',tumblr: '#36465e',snapchat: '#fbd408',soundcloud: '#fe4600',flickr: '#0162dd',youtube: '#d32323',pinterest: '#ca1f26',github: '#000000',tiktok: '#4c0f2e',goodreads: '#99632c',spotify: '#2db857',
                  },
                  socialAccounts: [
                    {
                      name: 'facebook',
                      icon: 'facebook',
                      field_prefix: 'facebook.com',
                    },
                    {
                      name: 'discord',
                      icon: 'discord',
                      field_prefix: 'discordapp.com',
                    },
                    {
                      name: 'whatsapp',
                      icon: 'whatsapp',
                      field_prefix: 'https://wa.me/',
                    },
                    {
                      name: 'twitter',
                      icon: 'twitter',
                      field_prefix: 'twitter.com',
                    },
                    {
                      name: 'codepen',
                      icon: 'codepen',
                      field_prefix: 'codepen.com',
                    },
                    {
                      name: 'instagram',
                      icon: 'instagram',
                      field_prefix: 'instagram.com',
                    },
                    {
                      name: 'reddit',
                      icon: 'reddit',
                      field_prefix: 'reddit.com',
                    },
                    {
                      name: 'linkedin',
                      icon: 'linkedin',
                      field_prefix: 'linkedin.com',
                    },
                    {
                      name: 'medium',
                      icon: 'medium',
                      field_prefix: 'medium.com',
                    },
                    {
                      name: 'vimeo',
                      icon: 'vimeo',
                      field_prefix: 'vimeo.com',
                    },
                    {
                      name: 'behance',
                      icon: 'behance',
                      field_prefix: 'behance.net',
                    },
                    {
                      name: 'fivehundredpx',
                      icon: '500px',
                      field_prefix: '500px.com',
                    },
                    {
                      name: 'dribbble',
                      icon: 'dribbble',
                      field_prefix: 'dribbble.com',
                    },
                    {
                      name: 'tumblr',
                      icon: 'tumblr',
                      field_prefix: 'tumblr.com',
                    },
                    {
                      name: 'snapchat',
                      icon: 'snapchat',
                      field_prefix: 'snapchat.com',
                    },
                    {
                      name: 'soundcloud',
                      icon: 'soundcloud',
                      field_prefix: 'soundcloud.com',
                    },
                    {
                      name: 'flickr',
                      icon: 'flickr',
                      field_prefix: 'flickr.com',
                    },
                    {
                      name: 'youtube',
                      icon: 'youtube',
                      field_prefix: 'youtube.com',
                    },
                    {
                      name: 'pinterest',
                      icon: 'pinterest',
                      field_prefix: 'pinterest.com',
                    },
                    {
                      name: 'website',
                      icon: 'website',
                      field_prefix: '9999999.com',
                    },
                    {
                      name: 'github',
                      icon: 'github',
                      field_prefix: 'github.com',
                    },
                    {
                      name: 'spotify',
                      icon: 'spotify',
                      field_prefix: 'spotify.com',
                    },
                    {
                      name: 'goodreads',
                      icon: 'goodreads',
                      field_prefix: 'goodreads.com',
                    },
                    {
                      name: 'tiktok',
                      icon: 'tiktok',
                      field_prefix: 'tiktok.com',
                    },
                  ],
                  socialAdd: null,
            }
        },
        methods: {
            save () {
                this.saving = true
                this.errors = {}
                this.$http.put('/portfolio/settings/', this.userProfile).then(data => {
                    this.userProfile = data.data
                    this.userProfile.clear_cv = false
                    this.saving = false
                    this.$store.dispatch('messages/success', this.$t('messages.settings-saved'))
                }).catch(errors => {
                    this.saving = null
                    if (errors.response && errors.response.data){
                        this.errors = errors.response.data
                    }
                })
            },
            changeCV($event){
                this.userProfile.cv=$event;
                this.save()
            },
            removeCV(){
                this.userProfile.cv=null
                this.save()
            },
            domainHelp (){
                window.Intercom('showNewMessage', this.$t('intercom.domain'));
            },
            removeSocialAccount(item){
              this.userSocialLinks.splice(this.userSocialLinks.indexOf(item), 1);
              this.saveSocialLinks()
            },
            addSocialLink(){
              this.errors = {}

              var socialAdd = null
              if( /(.+)@(.+){2,}\.(.+){2,}/.test(this.social_url) ){
                  socialAdd = 'email'
                  this.social_url = 'mailto:' + this.social_url
              }else if( /^\d+$/.test(this.social_url.replaceAll('-', '').replaceAll('+', '')) ){
                socialAdd = 'phone'
                this.social_url = 'tel:' + this.social_url
              }else if(this.social_url.startsWith('https://') || this.social_url.startsWith('http://')){
                socialAdd = 'website'
                for(var i=0;i<this.socialAccounts.length;i++){
                  if(this.social_url.indexOf(this.socialAccounts[i].field_prefix) !== -1){
                    socialAdd = this.socialAccounts[i].name
                  }
                }
              }else{
                this.errors['social_links'] = ["Enter a valid phone number, url (starting https://) or email address"]
                return
              }

              this.userSocialLinks.push({icon: socialAdd, data: this.social_url})
              this.social_url = ''
              this.saveSocialLinks()
            },
            saveSocialLinks(){
              this.$http
                .put('/portfolio/social-links/', this.userSocialLinks)
                .then((data) => {
                  this.userSocialLinks = data.data
                  this.$store.dispatch('messages/success', this.$t('Settings Saved'))
                })
            },
        },
        computed: {
            getPDFURL () {
                if(this.portfolio){
                    return this.portfolio.get_absolute_url+'/export.pdf'
                }else{
                    return ''
                }
            },
            user () {
                return this.$store.getters['auth/user']
            },
            portfolio () {
                return this.$store.getters['portfolio/portfolio']
            },
        },
        mounted () {
            this.$http
              .get('/portfolio/social-links/')
              .then((data) => {
                this.userSocialLinks = data.data
              })
            this.$http.get('/portfolio/settings/').then(data => {
                this.userProfile = data.data
            })
        }
    }
</script>
